import { render, staticRenderFns } from "./PromotionDetail.vue?vue&type=template&id=6f4216ec&scoped=true&"
import script from "./PromotionDetail.vue?vue&type=script&lang=js&"
export * from "./PromotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetail.vue?vue&type=style&index=0&id=6f4216ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4216ec",
  null
  
)

export default component.exports